import {
  useSynchFacilities,
  useSynchHealthSystems,
  useSynchStaffCategories,
  useSynchStaffJobs,
  useSynchStaffTypes,
  useSynchUnits,
} from "@/common/AppConfigUtils/store";

export const AppConfigSync = () => {
  useSynchStaffCategories();
  useSynchStaffTypes();
  useSynchFacilities();
  useSynchUnits();
  useSynchHealthSystems();
  useSynchStaffJobs();
  return <></>;
};
